import React, { useState } from "react";
import modelybanner from "../assets/modelyad.webp";
import "../style/Gravite.css";

import { db } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

const ModelY = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    state: "",
    city: "",
    buyingTime: "",
    agree: false,
  });

  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState("success");
  const [popupMessage, setPopupMessage] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.agree) {
      setPopupType("error");
      setPopupMessage("Please accept the marketing consent.");
      setShowPopup(true);
      return;
    }

    try {
      await addDoc(collection(db, "modelYLeads"), {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        mobile: formData.mobile,
        state: formData.state,
        city: formData.city,
        buyingTime: formData.buyingTime,
        agree: formData.agree,
        offer: "Tesla Model Y",
        createdAt: serverTimestamp(),
      });

      setPopupType("success");
      setPopupMessage(
        "Thank you! Your details have been submitted successfully."
      );
      setShowPopup(true);

      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        mobile: "",
        state: "",
        city: "",
        buyingTime: "",
        agree: false,
      });
    } catch (error) {
      console.error(error);

      setPopupType("error");
      setPopupMessage("Something went wrong. Please try again.");
      setShowPopup(true);
    }
  };

  return (
    <div className="gravite-page">
      {/* HERO */}
      <div className="gravite-hero">
        <div className="hero-image">
          <img src={modelybanner} alt="Tesla Model Y" />
        </div>

        <form className="lead-form" onSubmit={handleSubmit}>
          <h2>Get Expert Advice Now</h2>

          <input
            type="text"
            name="firstName"
            placeholder="First Name"
            value={formData.firstName}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="lastName"
            placeholder="Last Name"
            value={formData.lastName}
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <input
            type="tel"
            name="mobile"
            placeholder="Mobile"
            value={formData.mobile}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="state"
            placeholder="State"
            value={formData.state}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="city"
            placeholder="City"
            value={formData.city}
            onChange={handleChange}
            required
          />

          <label className="small-label">
            How soon are you looking to buy?
          </label>

          <select
            name="buyingTime"
            value={formData.buyingTime}
            onChange={handleChange}
            required
          >
            <option value="">Select</option>
            <option value="Within 1 Month">Within 1 Month</option>
            <option value="1-3 Months">1-3 Months</option>
            <option value="3-6 Months">3-6 Months</option>
            <option value="6+ Months">6+ Months</option>
          </select>

          <div className="checkbox-row">
            <input
              type="checkbox"
              name="agree"
              checked={formData.agree}
              onChange={handleChange}
            />

            <span>
              By submitting this form, you agree that your data may be used for
              marketing purposes.
            </span>
          </div>

          <button type="submit" className="submit-btn">
            Submit
          </button>
        </form>
      </div>

      {/* ABOUT */}
    <section className="about-gravite">
  <h2>Experience the New Tesla Model Y</h2>

  <p>
    Tesla has officially introduced the Model Y in India, bringing one of the
    world's best-selling electric SUVs to Indian buyers. The Model Y offers a
    minimalist premium cabin, advanced Autopilot features, impressive driving
    range, all-wheel-drive capability, and a spacious 2+2+2 seating layout.
    With rapid acceleration, over-the-air software updates, and Tesla's
    Supercharger ecosystem, the Model Y is designed for customers seeking
    cutting-edge electric mobility with premium performance.
  </p>
</section>

      {/* TABLE */}
    <section className="tech-data">
  <h2>Technical Specifications of the Tesla Model Y</h2>

  <table>
    <thead>
      <tr>
        <th>Specification</th>
        <th colSpan="4">Tesla Model Y</th>
      </tr>
    </thead>

    <tbody>
      <tr>
        <td>Expected Price</td>
        <td colSpan="4">₹60–70 Lakh (Ex-Showroom)</td>
      </tr>

      <tr>
        <td>Powertrain</td>
        <td colSpan="4">Dual Electric Motors (AWD)</td>
      </tr>

      <tr>
        <td>Battery Pack</td>
        <td colSpan="4">75 kWh (Approx.)</td>
      </tr>

      <tr>
        <td>Power Output</td>
        <td colSpan="4">384 PS (Approx.)</td>
      </tr>

      <tr>
        <td>Torque</td>
        <td colSpan="4">510 Nm (Approx.)</td>
      </tr>

      <tr>
        <td>Driving Range</td>
        <td colSpan="4">Up to 533 km (WLTP)</td>
      </tr>

      <tr>
        <td>Acceleration</td>
        <td colSpan="4">0–100 km/h in 5.0 seconds</td>
      </tr>

      <tr>
        <td>Drive Type</td>
        <td colSpan="4">All-Wheel Drive (AWD)</td>
      </tr>

      <tr>
        <td>Infotainment</td>
        <td colSpan="4">15.4-inch Central Touchscreen</td>
      </tr>

      <tr>
        <td>Seating</td>
        <td colSpan="4">2+2+2 Premium Seating Layout</td>
      </tr>

      <tr>
        <td>Safety</td>
        <td colSpan="4">
          Autopilot, Multiple Airbags, 360° Cameras, Collision Avoidance
        </td>
      </tr>
    </tbody>
  </table>
</section>
      {/* CUSTOM POPUP */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div
              className={`popup-icon ${
                popupType === "success" ? "success" : "error"
              }`}
            >
              {popupType === "success" ? "✓" : "✕"}
            </div>

            <h3>
              {popupType === "success"
                ? "Submitted Successfully"
                : "Submission Failed"}
            </h3>

            <p>{popupMessage}</p>

            <button
              className="popup-btn"
              onClick={() => setShowPopup(false)}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ModelY;